module.exports = __webpack_public_path__ + "assets/Footer.f75209f9.svg";